// extracted by mini-css-extract-plugin
export default {"wrapper":"line-select_wrapper__2fkJV","option":"line-select_option__jFwRL","active":"line-select_active__mit6A","label":"line-select_label__EX152"};